import axios from 'axios';
import toast from 'react-hot-toast';

// Create axios instance
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
});

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.error?.message || 'An error occurred';
    
    // Don't show toast for validation errors (400) - let components handle them
    if (error.response?.status !== 400) {
      toast.error(message);
    }

    return Promise.reject(error);
  }
);

// Onboarding API - For client lead family member capture
export const onboardingAPI = {
  validateToken: (token) => api.get(`/onboarding/validate/${token}`),
  submitOnboarding: (data) => api.post('/onboarding/submit', data),
};

// Evaluation API - Only what's needed for public frontend
export const evaluationAPI = {
  validateToken: (token) => api.post('/evaluation/validate-token', { token }),
  getQuestions: (token) => api.get(`/evaluation/questions/${token}`),
  saveProgress: (data) => api.post('/evaluation/save-progress', data),
  submitEvaluation: (data) => api.post('/evaluation/submit', data),
  getStatus: (token) => api.get(`/evaluation/status/${token}`),
  recordConsent: (data) => api.post('/evaluation/record-consent', data),
};

// Utility functions
export const handleApiError = (error, customMessage = null) => {
  const message = customMessage || error.response?.data?.error?.message || 'An error occurred';
  console.error('API Error:', error);
  toast.error(message);
  return message;
};

export default api;